module.exports = __webpack_public_path__ + "static/digital-transformation-main-banner-0938bbae55ba595dfe75fb67907287cb.svg";